<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		children: Snippet;
		class?: ClassValue;
	}

	let { children, class: className }: Props = $props();
</script>

<div class={['box bg-dot-pattern text-background-on-container grow flex-col', className]}>
	{@render children()}
	<div class="p-s400 flex shrink-0 items-center justify-center">
		<p class="text-h2 text-center">Matrix Client</p>
	</div>
</div>
